var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React from 'react';
import { Sidepanel } from "../../../../Components/UI";
import { Translate } from "../../../../../I18N";

import { ActionPill } from "./TableElements";






const ActivityLogSidePanel = ({ selectedEntry, isOpen, onClose }) => /*#__PURE__*/
_jsx(Sidepanel, {
  withOverlay: true,
  isOpen: isOpen,
  closeSidepanelFunction: onClose,
  title: /*#__PURE__*/_jsx(Translate, { className: "uppercase" }, void 0, "Activity"),
  "data-testid": "activity-log-detail" }, void 0, /*#__PURE__*/

_jsx(Sidepanel.Body, {}, void 0,
selectedEntry !== undefined && /*#__PURE__*/
React.createElement(React.Fragment, null, /*#__PURE__*/
_jsx("div", { className: "flex flex-col" }, void 0, /*#__PURE__*/
_jsx("div", { className: "flex flex-row justify-between w-full p-5 my-2 rounded-lg bg-gray-50" }, void 0,
selectedEntry.semantic.action !== 'RAW' && /*#__PURE__*/
React.createElement(React.Fragment, null, /*#__PURE__*/
_jsx("div", { className: "flex-col" }, void 0,
selectedEntry.semantic.description && /*#__PURE__*/
_jsx("div", {}, void 0, /*#__PURE__*/
_jsx(Translate, { className: "font-semibold text-primary-700" }, void 0,
selectedEntry.semantic.description
), ":"

), /*#__PURE__*/

_jsx("div", {}, void 0,
selectedEntry.semantic.name && /*#__PURE__*/
_jsx(Translate, {}, void 0, selectedEntry.semantic.name),

selectedEntry.semantic.extra && /*#__PURE__*/
_jsx(Translate, {}, void 0, selectedEntry.semantic.extra)

)
), /*#__PURE__*/
_jsx(ActionPill, { className: "h-6", action: selectedEntry.semantic.action })
),

selectedEntry.semantic.action === 'RAW' && /*#__PURE__*/
_jsx("div", { className: "content-start space-x-1" }, void 0, /*#__PURE__*/
_jsx(Translate, { className: "font-semibold" }, void 0, selectedEntry.method), ":", /*#__PURE__*/
_jsx(Translate, {}, void 0, selectedEntry.url)
)

)
), /*#__PURE__*/
_jsx("div", { className: "flex flex-row justify-between w-full p-5 my-2 border rounded-lg border-gray-50 bg-gray-30" }, void 0, /*#__PURE__*/
_jsx("div", { className: "flex flex-col" }, void 0, /*#__PURE__*/
_jsx(Translate, { className: "font-semibold" }, void 0, "User"), /*#__PURE__*/
_jsx("span", { className: "text-primary-700" }, void 0, selectedEntry.username)
)
), /*#__PURE__*/
_jsx("div", { className: "flex flex-col flex-grow p-3 rounded-lg max-h-svh h-3/4" }, void 0, /*#__PURE__*/
_jsx(Translate, { className: "m-2 font-semibold" }, void 0, "Query"), /*#__PURE__*/
_jsx("span", { className: "block p-5 mb-4 text-gray-900 border border-gray-300 rounded-lg bg-gray-50" }, void 0,
selectedEntry.query
), /*#__PURE__*/
_jsx(Translate, { className: "m-2 font-semibold" }, void 0, "Body"), /*#__PURE__*/
_jsx("span", { className: "block w-full p-3 overflow-auto text-gray-900 border border-gray-300 rounded-lg bg-gray-50 " }, void 0,
selectedEntry.body
)
)
)

)
);


export { ActivityLogSidePanel };